<div class="main-layout" [@routesAnimations]="getAnimationState(outlet)">
  <router-outlet #outlet="outlet"></router-outlet>
</div>
<footer>
  <p>ngAuth - Gian López © 2021</p>
</footer>